<template>
  <div class="oll-Loader">
    <AppRiveScene
      file-src="https://s3-oboard-public-static.s3.eu-central-1.amazonaws.com/img/logo-loader.riv"
      autoplay
      loop
    >
      <template #fallback>
        <div class="oll-Loader_Logo">
          <SkeletonItem
            :appearance="SKELETON_APPEARANCES.CIRCLE"
            animation-opacity="0.2"
            class="oll-Loader_Item"
            color="#5879EE"
            height="48px"
            width="48px"
          />

          <div class="oll-Loader_Middle">
            <SkeletonItem
              animation-opacity="0.2"
              border-radius="24px"
              class="oll-Loader_Item"
              color="#FF8541"
              height="48px"
              width="96px"
            />

            <SkeletonItem
              animation-opacity="0.2"
              border-radius="24px"
              class="oll-Loader_Item"
              color="#A769F6"
              height="48px"
              width="100%"
            />
          </div>

          <SkeletonItem
            animation-opacity="0.2"
            border-radius="24px"
            class="oll-Loader_Item"
            color="#F64963"
            height="48px"
            width="96px"
          />
        </div>
      </template>
    </AppRiveScene>
  </div>
</template>

<script setup>
import { SKELETON_APPEARANCES } from '@/utils/components-configurations/skeleton-item'

import AppRiveScene from '@/components/ui/AppRiveScene/AppRiveScene'
import SkeletonItem from '@/components/ui/SkeletonLoaders/SkeletonItem'

defineOptions({
  name: 'OboardLogoLoader'
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/canvas-dimensions';

.oll-Loader {
  height: var(--height, #{$fullscreen-canvas-height});
  display: flex;
  justify-content: center;
  align-items: center;
}

.oll-Loader_Logo {
  height: 160px;
  width: 160px;
  display: grid;
  gap: 8px;
}

.oll-Loader_Item {
  &:nth-child(1) {
    margin-left: auto;
  }
}

.oll-Loader_Middle {
  position: relative;
  .oll-Loader_Item {
    &:nth-child(1) {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
    }
  }
}
</style>
